<app-layout>
    <h1 class="mb-8 font-bold text-3xl">
        <Link class="text-indigo-400 hover:text-indigo-600" :href="route('admin.users.edit', filters.referrer)" v-if="filters.referrer">Go Back - </Link> KYC Documents
    </h1>
    <div class="mb-6 flex justify-between items-center">
        <search-filter :filter="false" v-model="form.search" class="w-full max-w-md mr-4 focus:outline-none" @reset="reset">

        </search-filter>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
        <table class="w-full whitespace-no-wrap">
            <tr class="text-left font-bold">
                <th class="px-3 pt-6 pb-4">User Data</th>
                <th class="px-3 pt-6 pb-4">Country</th>
                <th class="px-3 pt-6 pb-4">Selfie Photo</th>
                <th class="px-3 pt-6 pb-4">Documents</th>
                <th class="px-3 pt-6 pb-4">Status</th>
                <th class="px-3 pt-6 pb-4">Submit Date</th>
                <th class="px-3 pt-6 pb-4">Actions</th>
            </tr>
            <tr v-for="document in kycDocuments.data" :key="document.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center focus:text-indigo-500">
                        {{ document.first_name }} <br>
                        {{ document.last_name }} <br>
                        {{ document.middle_name }} <br>
                        {{ document.user.email }}
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center focus:text-indigo-500">
                        {{ document.country.name }}
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center focus:text-indigo-500">
                        <font-awesome-icon @click="showModal([document.selfie])" icon="external-link-alt" class="cursor-pointer" />
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center focus:text-indigo-500">
                        <font-awesome-icon @click="showModal([document.front, document.back])" icon="external-link-alt" class="cursor-pointer" />
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center focus:text-indigo-500">
                        <badge v-if="document.status == 'pending'" class="mr-2" type="orange">
                            Pending
                        </badge>
                        <badge v-if="document.status == 'approved'" class="mr-2" type="green">
                            Approved
                        </badge>
                        <badge v-if="document.status == 'rejected'" class="mr-2 cursor-pointer" type="red">
                            <div @click="showReason(document)">
                                <span class="mr-1">Rejected</span><font-awesome-icon icon="info-circle" />
                            </div>
                        </badge>
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center focus:text-indigo-500">
                        {{ document.created_at }}
                    </span>
                </td>
                <td class="border-t">
                    <span v-if="document.status == 'pending'" class="px-6 py-4 flex items-center focus:text-indigo-500">
                        <t-button-green @click="approve(document)" class="mr-2">Approve</t-button-green>
                        <t-button-red @click="reject(document)">Reject</t-button-red>
                    </span>
                </td>
            </tr>
            <tr v-if="kycDocuments.data.length === 0">
                <td class="border-t px-6 py-4" colspan="100">No kyc documents found.</td>
            </tr>
        </table>
    </div>
    <pagination :links="kycDocuments.links" />

    <!-- Show User Document Modal -->
    <jet-dialog-modal :show="showImage" @close="closeModal">
        <template #title>
            KYC Image
        </template>
        <template #content>
            <div v-for="image in images">
                <img v-if="image" width="100%" :src="image.url" />
            </div>
        </template>

        <template #footer>
            <jet-secondary-button @click.native="closeModal">
                Close
            </jet-secondary-button>
        </template>
    </jet-dialog-modal>

    <!-- Show Rejection Reason Modal -->
    <jet-dialog-modal :show="showReasonModal" @close="closeReasonModal">
        <template #title>
            Rejected Reason
        </template>

        <template #content>
            <div v-html="rejectedReason"></div>
        </template>

        <template #footer>
            <jet-secondary-button @click.native="closeReasonModal">
                Close
            </jet-secondary-button>
        </template>
    </jet-dialog-modal>

    <!-- Confirmation Modal -->
    <jet-confirmation-modal :show="documentBeingReviewed">
        <template #title>
            Confirmation modal
        </template>

        <template #content>
            <div v-if="selectedAction == 'approve'">Are you sure you would like to {{ selectedAction }} the document?</div>

            <div v-if="selectedAction == 'reject'" class="flex flex-wrap">
                Please write down the rejection reason
                <t-textarea v-model="rejectedReasonText" class="mt-5 w-full"></t-textarea>
            </div>
        </template>

        <template #footer>
            <jet-secondary-button @click.native="documentBeingReviewed = null">
                Nevermind
            </jet-secondary-button>

            <jet-danger-button class="ml-2" @click.native="confirmAction">
                {{ selectedAction }}
            </jet-danger-button>
        </template>
    </jet-confirmation-modal>

</app-layout>
